import { gql } from "@apollo/client"

export const GET_INIT_UPLOAD_INFO = gql`
    query getInitUploadInfo {
        availableLanguages {
            code
            name
            id
        }
        getAudioFormats {
            id
            name
            encoding
            type
        }
    }
`
